import { render, staticRenderFns } from "./CustomerCartDetailPromo.vue?vue&type=template&id=12b0ff57&scoped=true"
import script from "./CustomerCartDetailPromo.vue?vue&type=script&lang=js"
export * from "./CustomerCartDetailPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0ff57",
  null
  
)

export default component.exports